import React from "react";
import { MdOutlineAddShoppingCart } from "react-icons/md";
import ReadMore from "../../../../features/ReadMore";
import { Assort } from "../../../models/Assort";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import "../style.scss";
import "./../../Passes/SinglePass/style.scss";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  item: Assort;
}

const SingleGiftCard: React.FC<IProps> = ({ item }: IProps) => {
  const { handleAddBasketLimited } = useBasketManager();
  const { t } = useTranslation();
  return (
    <div className="singlePass">
      <div className="img" style={{ backgroundImage: `url(${item.picture})` }}></div>
      <div className="content">
        <div className="text">
          <h3>{item.displayWebName}</h3>
          {item.description.length > 120 ? (
            <ReadMore text={item.description} minLengthText={120} title={item.displayWebName} />
          ) : (
            <article dangerouslySetInnerHTML={{ __html: item.description }}></article>
          )}
        </div>
        <div className="line"></div>
        <div className="buttons flex-between-center">
          <div className="flex-column flex-wrap">
            <b>
              {item.price} {t("zl")}
            </b>
            {/* <span>Ważność {item.dayValidate} dni</span> */}
          </div>
          <EAButton
            onClick={() => {
              handleAddBasketLimited(item, 1);
            }}
            title={t("dodaj")}
            endIcon={<MdOutlineAddShoppingCart />}
          />
        </div>
      </div>
    </div>
  );
};

export default SingleGiftCard;
